export default __webpack_public_path__ + "static/developer@2x-e1ca643d48f4f407aed524bd64ade291.png";